import { ProjectTypes } from '@/interfaces/project-type';

export function hiddenBedroom(value: string, arg: number): string | undefined {
    return [ProjectTypes.Office, ProjectTypes.Plot].includes(arg) ? '-' : value;
}
